import lang from '@/lang'
import { Node, mergeAttributes } from '@tiptap/core'

const PageBreak = Node.create({
  name: 'pageBreak',
  group: 'block',
  atom: true,

  addAttributes() {
    return {
      class: {
        default: 'page-break',
      },
    }
  },

  parseHTML() {
    return [
      { tag: 'div.page-break' },
      { tag: 'div[style*="page-break-after"]' },
    ]
  },

  renderHTML({ HTMLAttributes }) {
    // Output HTML for backend
    return ['div', mergeAttributes(HTMLAttributes, {
      class: 'page-break',
      style: 'page-break-after:always;',
    }), ['span', { style: 'display:none;' }, '\u00A0']]
  },

  addNodeView() {
    return () => {
      const dom = document.createElement('div')
      dom.className = 'page-break-view'
      dom.style.cssText = 'border-top: 2px dashed #ccc; margin: 20px 0; background: none; position: relative;'

      const label = document.createElement('span')
      label.textContent = lang.htmlInput.extensions.pageBreak.label
      label.style.cssText = 'position: absolute; top: -10px; left: 50%; transform: translateX(-50%); background: white; padding: 0 8px; font-size: 11px; color: #999;'
      dom.appendChild(label)

      return {
        dom,
        contentDOM: null,
      }
    }
  },
})

export default PageBreak
